import './../../styles/Account.css';

import Container from '../../components/Layout/Container';

import Input, { onEnter } from '../../components/TextField/Input';
import { Button } from '../../components/Button/Button';

import { useState } from 'react';
import { fetchPost } from '../../hooks/fetch';
import { openAlert } from '../../components/Modal/MsgBox';
import { handleVerificationCode, isBlankStr } from '../../hooks/useValidate';

export default function ResetPassword() {
	const pageName = '아이디 변경';
	const [crisInfo, setCrisInfo] = useState({ originLoginId: "", newLoginId: "", newPassword: "", verificationCode: "" });
	const [sendVerifyCode, setSendVerifyCode] = useState(false);

	const onChangeCrisInfo = (e) => {
		const { name, value } = e.target;
		setCrisInfo({
			...crisInfo,
			[name]: name === "verificationCode" ? handleVerificationCode(value) : value
		});
	}

	const onKeyDown = (e) => {
		onEnter(e, submit);
	}

	const validate = () => {
		if(isBlankStr(crisInfo.originLoginId)) {
			openAlert("기존 아이디를 입력해 주세요.");
			return false;
		}
		if(isBlankStr(crisInfo.newLoginId)) {
			openAlert("변경 아이디를 입력해 주세요.");
			return false;
		}
		if(isBlankStr(crisInfo.newPassword)) {
			openAlert("비밀번호를 입력해 주세요.");
			return false;
		}
		return true;
	}

	function sendEmailVerifyCode() {
		if(!validate()) return;

		fetchPost(
			"/emailVerification/send/changeid",
			"인증번호를 전송",
			{ 
				originLoginId: crisInfo.originLoginId,
				newLoginId: crisInfo.newLoginId,
				newPassword: crisInfo.newPassword
			},
			() => { setSendVerifyCode(true) }
		)
	}

	function submit() {
		if(!validate()) return;
		
		if(!sendVerifyCode) {
			openAlert("인증 번호를 요청 해주세요.");
			return false;
		}
		if(isBlankStr(crisInfo.verificationCode)) {
			openAlert("인증번호를 입력해 주세요.");
			return false;
		}

		fetchPost(
			"/emailVerification/check/changeid",
			"아이디 변경에 성공",
			crisInfo,
			() => { window.location.replace("/account/login") }
		)
	}

	return (
		<main id="account-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<Container>
				<div className="page-content login-page">
					<div className="gs-account-form">
						<h1 className="top">{pageName}</h1>
						<p className="gs-bullet fc-cerulean-blue" style={{ letterSpacing: '-0.8px' }}>
							사번이 변경되신 분은 아이디를 변경된 사번으로 변경하셔야 로그인이 가능합니다.
						</p>
						<div>
							<Input.Group>
								<Input
									id="user-id"
									type="email"
									label="기존 아이디(이전 CRIS 사번)를 입력해주세요."
									placeholder="기존 아이디(이전 CRIS 사번) 입력"
									name="originLoginId"
									value={crisInfo.originLoginId}
									onChange={onChangeCrisInfo}
									onKeyDown={onKeyDown}
									maxLength={30}
								/>
								<Input
									id="user-new-id"
									type="email"
									label="변경 아이디(신규 CRIS 사번)를 입력해주세요."
									placeholder="변경 아이디(신규 CRIS 사번) 입력"
									name="newLoginId"
									value={crisInfo.newLoginId}
									onChange={onChangeCrisInfo}
									onKeyDown={onKeyDown}
									maxLength={30}
								/>
								<Input.PasswordEye
									id="user-new-password"
									label="비밀번호를 입력해주세요."
									placeholder="비밀번호(신규 CRIS 비밀번호) 입력"
									name="newPassword"
									value={crisInfo.newPassword}
									onChange={onChangeCrisInfo}
									onKeyDown={onKeyDown}
									maxLength={20}
								/>
								<div className="gs-input-box flex">
									<Input
										id="authentication-num"
										type="tel"
										label="인증번호를 입력해주세요."
										placeholder="인증번호 입력"
										name="verificationCode"
										value={crisInfo.verificationCode}
										onChange={onChangeCrisInfo}
										maxLength={6}
										onKeyDown={onKeyDown}
									/>
									<Button
										type="button"
										className="full silver"
										onClick={sendEmailVerifyCode}
									>
										인증번호 요청
									</Button>
								</div>
							</Input.Group>
							<div className="gs-bottom-btns col">
								<Button
									className="submit"
									onClick={submit}
								>
									<strong>확 인</strong>
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Container>
		</main>
	);
}
